import {
  responsibleCustodyForceValues,
  type ResponsibleCustodyForce,
  type StaticOptionsList,
} from "../../types/index.js";
import { tk, type TranslationKey } from "../../types/Translation.js";

/**
 * A label for every force a custody suite can belong to. Keyed by the schema's
 * own type, so a force added to it without a label here fails to compile.
 */
const responsibleCustodyForceLabels: Record<
  ResponsibleCustodyForce,
  TranslationKey
> = {
  avonAndSomerset: tk("custodySuite.responsibleForce.options.avonAndSomerset"),
  bedfordshire: tk("custodySuite.responsibleForce.options.bedfordshire"),
  cambridgeshire: tk("custodySuite.responsibleForce.options.cambridgeshire"),
  cheshire: tk("custodySuite.responsibleForce.options.cheshire"),
  cityOfLondon: tk("custodySuite.responsibleForce.options.cityOfLondon"),
  cleveland: tk("custodySuite.responsibleForce.options.cleveland"),
  cumbria: tk("custodySuite.responsibleForce.options.cumbria"),
  derbyshire: tk("custodySuite.responsibleForce.options.derbyshire"),
  devonAndCornwall: tk(
    "custodySuite.responsibleForce.options.devonAndCornwall",
  ),
  dorset: tk("custodySuite.responsibleForce.options.dorset"),
  durham: tk("custodySuite.responsibleForce.options.durham"),
  dyfedPowys: tk("custodySuite.responsibleForce.options.dyfedPowys"),
  essex: tk("custodySuite.responsibleForce.options.essex"),
  gloucestershire: tk("custodySuite.responsibleForce.options.gloucestershire"),
  greaterManchester: tk(
    "custodySuite.responsibleForce.options.greaterManchester",
  ),
  gwent: tk("custodySuite.responsibleForce.options.gwent"),
  hampshire: tk("custodySuite.responsibleForce.options.hampshire"),
  hertfordshire: tk("custodySuite.responsibleForce.options.hertfordshire"),
  humberside: tk("custodySuite.responsibleForce.options.humberside"),
  kent: tk("custodySuite.responsibleForce.options.kent"),
  lancashire: tk("custodySuite.responsibleForce.options.lancashire"),
  leicestershire: tk("custodySuite.responsibleForce.options.leicestershire"),
  lincolnshire: tk("custodySuite.responsibleForce.options.lincolnshire"),
  merseyside: tk("custodySuite.responsibleForce.options.merseyside"),
  metropolitanPolice: tk(
    "custodySuite.responsibleForce.options.metropolitanPolice",
  ),
  norfolk: tk("custodySuite.responsibleForce.options.norfolk"),
  northWales: tk("custodySuite.responsibleForce.options.northWales"),
  northYorkshire: tk("custodySuite.responsibleForce.options.northYorkshire"),
  northamptonshire: tk(
    "custodySuite.responsibleForce.options.northamptonshire",
  ),
  northumbria: tk("custodySuite.responsibleForce.options.northumbria"),
  nottinghamshire: tk("custodySuite.responsibleForce.options.nottinghamshire"),
  southWales: tk("custodySuite.responsibleForce.options.southWales"),
  southYorkshire: tk("custodySuite.responsibleForce.options.southYorkshire"),
  staffordshire: tk("custodySuite.responsibleForce.options.staffordshire"),
  suffolk: tk("custodySuite.responsibleForce.options.suffolk"),
  surrey: tk("custodySuite.responsibleForce.options.surrey"),
  sussex: tk("custodySuite.responsibleForce.options.sussex"),
  thamesValley: tk("custodySuite.responsibleForce.options.thamesValley"),
  warwickshire: tk("custodySuite.responsibleForce.options.warwickshire"),
  westMercia: tk("custodySuite.responsibleForce.options.westMercia"),
  westMidlands: tk("custodySuite.responsibleForce.options.westMidlands"),
  westYorkshire: tk("custodySuite.responsibleForce.options.westYorkshire"),
  wiltshire: tk("custodySuite.responsibleForce.options.wiltshire"),
  policeScotland: tk("custodySuite.responsibleForce.options.policeScotland"),
  psni: tk("custodySuite.responsibleForce.options.psni"),
  britishTransportPolice: tk(
    "custodySuite.responsibleForce.options.britishTransportPolice",
  ),
  ministryOfDefencePolice: tk(
    "custodySuite.responsibleForce.options.ministryOfDefencePolice",
  ),
  civilNuclearConstabulary: tk(
    "custodySuite.responsibleForce.options.civilNuclearConstabulary",
  ),
};

/**
 * Option labels for `responsibleCustodyForceSchema`, built from the schema's
 * values so the two cannot drift.
 */
export const responsibleCustodyForceOptions: StaticOptionsList =
  responsibleCustodyForceValues.map((value) => ({
    value,
    label: responsibleCustodyForceLabels[value],
  }));
